import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalender5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCalender5"><Path d="M20.5 7.5V20.5H3.5V7.5V3.5H7.5V5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 7.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 7.5V3.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 3.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 3.5V5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCalender5;
